import { useEffect, useState } from 'react';
import SetupProgress from './SetupProgress';
import FAQ from './FAQ';
import DiscountCard from './DiscountCard';
import Header from './Header';
import { IonContent, IonIcon, IonPage } from '@ionic/react';
import { closeOutline, informationCircle } from 'ionicons/icons';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store/store';
import { dashboardPageStyle } from '../../Layout';

export default function GettingStarted() {
  const userProfile = useSelector((state: RootState) => state.userProfile);
  const { activeStore, hasStore } = useSelector(
    (state: RootState) => state.userStores
  );

  const progress = userProfile?.profile_progress_percent ?? 0;
  const isIncomplete = progress < 100 || !hasStore;

  const [showIncompleteAlert, setShowIncompleteAlert] = useState(isIncomplete);

  useEffect(() => {
    setShowIncompleteAlert(isIncomplete);
  }, [isIncomplete]);

  return (
    <IonPage>
      <IonContent>
        <div className={dashboardPageStyle}>
          {showIncompleteAlert && (
            <div className="flex items-center justify-between bg-[#effaf6] text-green-800 text-sm p-2 border border-gray-300 rounded-md">
              <div className="flex-1 flex items-center justify-center gap-2">
                <IonIcon
                  icon={informationCircle}
                  className="text-lg text-[#0f5d66]"
                />
                <span className="text-text-dark-high dark:text-text-light-high">
                  Your profile is currently inactive, complete your profile to
                  re-activate.
                </span>
              </div>
              <IonIcon
                onClick={() => setShowIncompleteAlert(false)}
                icon={closeOutline}
                className="cursor-pointer text-lg text-[#0f5d66]"
              />
            </div>
          )}

          <Header
            storeName={userProfile?.user?.first_name}
            logo={activeStore?.media?.logo?.file_url}
            banner={activeStore?.media?.banner?.file_url}
          />

          <div className="grid grid-cols-1 lg:grid-cols-[4fr_2.3fr] gap-4">
            <div className="min-w-0">
              <SetupProgress />
            </div>
            <div className="min-w-0 flex flex-col gap-4">
              <FAQ />
              <DiscountCard />
            </div>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
}
